if (!customElements.get('video-player')) {
  const loadYouTubeAPI = (() => {
    let ready = false;
    let callbacks = [];

    return function (cb) {
      if (window.YT && YT.Player) return cb();
      callbacks.push(cb);
      if (!ready) {
        ready = true;
        window.onYouTubeIframeAPIReady = () => {
          callbacks.forEach((fn) => fn());
          callbacks = [];
        };
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(script);
      }
    };
  })();

  class VideoPlayer extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector('video');
      this.iframe = this.querySelector('iframe');
      this.iframeType = this.iframe?.dataset.videoType;
      this.isMuted = true;
      this.isPaused = true;
      this.btnMute = this.querySelector('[data-button-mute]');
      this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    }

    connectedCallback() {
      if (this.iframe) {
        this.initIframePlayer();
      }

      this.addEventListener('click', (e) => {
        if (this.hoverMedia.matches) return;

        if (this.isPaused) {
          this.pauseOtherPlayers();
          this.playVideo();

          return;
        }

        this.pauseVideo();
      });

      this.hoverMedia.addEventListener('change', (e) => {
        this.pauseVideo();
      });

      this.addEventListener('pointerenter', (e) => {
        if (!this.hoverMedia.matches) return;

        this.playVideo(false);
      });

      this.addEventListener('pointerleave', (e) => {
        if (!this.hoverMedia.matches) return;

        this.pauseVideo(false);
      });

      this.btnMute.addEventListener('click', (e) => {
        if (!this.hoverMedia.matches) return;

        this.isMuted ? this.unmuteVideo() : this.muteVideo();
      });
    }

    initIframePlayer() {
      if (this.iframe.dataset.videoType === 'vimeo') {
        this.player = new Vimeo.Player(this.iframe);
      } else if (this.iframe.dataset.videoType === 'youtube') {
        loadYouTubeAPI(() => {
          this.player = new YT.Player(this.iframe);
        });
      }
    }

    playVideo(changeMute = true) {
      if (this.player) {
        this.iframeType === 'vimeo'
          ? this.player.play()
          : this.player.playVideo();
      } else {
        this.video.play();
      }

      this.isPaused = false;
      if (changeMute) this.unmuteVideo();
    }

    pauseVideo(changeMute = true) {
      if (this.player) {
        this.iframeType === 'vimeo'
          ? this.player.pause()
          : this.player.pauseVideo();
      } else {
        this.video.pause();
      }

      this.isPaused = true;
      if (changeMute) this.muteVideo();
    }

    muteVideo() {
      if (this.player) {
        this.iframeType === 'vimeo'
          ? this.player.setMuted(true)
          : this.player.mute();
      } else {
        this.video.muted = true;
      }

      this.isMuted = true;
      this.classList.remove('is-unmuted');
    }

    unmuteVideo() {
      if (this.player) {
        this.iframeType === 'vimeo'
          ? this.player.setMuted(false)
          : this.player.unMute();
      } else {
        this.video.muted = false;
      }

      this.isMuted = false;
      this.classList.add('is-unmuted');
    }

    pauseOtherPlayers() {
      const players = document.querySelectorAll('video-player');

      players.forEach((player) => {
        if (player === this) return;

        player.pauseVideo();
      });
    }
  }

  customElements.define('video-player', VideoPlayer);
}
